import React from 'react';
import { useNavigate } from 'react-router-dom';

const Landing = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <div 
        className="relative min-h-screen flex items-center justify-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.6)), url('https://images.unsplash.com/photo-1444703686981-a3abbc4d4fe3')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Modern Human <span className="bg-gradient-to-r from-emerald-400 to-teal-300 bg-clip-text text-transparent">Being</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-3xl mx-auto leading-relaxed">
            A Consciousness-First Platform for Personal Evolution, Mind/Body Health Strategy, Anti-Aging, Eco-Living, and Collective Awakening.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => navigate('/register')}
              className="px-8 py-4 bg-gradient-to-r from-emerald-500 to-teal-600 text-white rounded-full font-semibold text-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
            >
              Begin Your Journey ✨
            </button>
            <button
              onClick={() => navigate('/login')}
              className="px-8 py-4 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full font-semibold text-lg hover:bg-white/30 transition-all duration-300"
            >
              Welcome Back 🙏
            </button>
            <button
              onClick={() => navigate('/guest-feed')}
              className="px-6 py-3 border-2 border-white/50 text-white rounded-full font-medium text-base hover:bg-white/20 transition-all duration-300"
            >
              Just Visiting 👁️
            </button>
          </div>
        </div>
        
        {/* Floating Elements */}
        <div className="absolute top-20 left-10 w-16 h-16 bg-gradient-to-br from-emerald-400/30 to-teal-500/30 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-24 h-24 bg-gradient-to-br from-purple-400/30 to-pink-500/30 rounded-full blur-xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 right-20 w-12 h-12 bg-gradient-to-br from-cyan-400/30 to-blue-500/30 rounded-full blur-xl animate-pulse delay-500"></div>
      </div>

      {/* Features Section */}
      <div className="py-20 bg-gradient-to-br from-emerald-50 to-teal-100">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">
            Awaken Your <span className="bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">Consciousness</span>
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl">🧘</span>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-800">Daily Affirmations</h3>
              <p className="text-gray-600 leading-relaxed">
                Start each day with personalized affirmations that align with your consciousness journey and spiritual growth.
              </p>
            </div>

            <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl">🌱</span>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-800">Reality Garden</h3>
              <p className="text-gray-600 leading-relaxed">
                Plant seeds of intention in our community garden where collective support manifests dreams into reality.
              </p>
            </div>

            <div className="text-center p-8 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl">🌳</span>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-800">Grove Communities</h3>
              <p className="text-gray-600 leading-relaxed">
                Connect with like-minded souls in your region through meaningful gatherings and conscious events.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="py-20 bg-gradient-to-r from-emerald-600 to-teal-600">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-4xl font-bold text-white mb-6">
            Ready to Elevate Your Consciousness?
          </h2>
          <p className="text-xl text-emerald-100 mb-8 max-w-3xl mx-auto leading-relaxed">
            A Consciousness-First Platform for Personal Evolution, Mind/Body Health Strategy, Anti-Aging, Eco-Living, and Collective Awakening.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button
              onClick={() => navigate('/register')}
              className="px-10 py-4 bg-white text-emerald-600 rounded-full font-bold text-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
            >
              Start Your Awakening Journey ✨
            </button>
            <button
              onClick={() => navigate('/guest-feed')}
              className="px-8 py-3 border-2 border-white text-white rounded-full font-medium text-lg hover:bg-white hover:text-emerald-600 transition-all duration-300"
            >
              Just Visiting 👁️
            </button>
          </div>
          <p className="text-emerald-200 text-sm mt-4">
            Just visiting? Browse our consciousness feed without registering
          </p>
        </div>
      </div>
    </div>
  );
};

export default Landing;